import { render, staticRenderFns } from "./buttonLayout.vue?vue&type=template&id=48de5c37&scoped=true&"
import script from "./buttonLayout.vue?vue&type=script&lang=js&"
export * from "./buttonLayout.vue?vue&type=script&lang=js&"
import style0 from "./buttonLayout.vue?vue&type=style&index=0&id=48de5c37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de5c37",
  null
  
)

export default component.exports